
<div class="chat-boat-footer d-flex align-items-start justify-content-center w-100 px-3">
  <div class="top mt-3" style="flex: 1 !important;">
    <div class="w-100 d-flex align-items-center" style="width: fit-content !important; width: 100% !important">
      <div class="form-control message" style="width: 100%;">
        <input id="text" autocomplete="off" #inputRef maxlength="750" dir="auto"
               [placeholder]='"Type your message..."'
               [(ngModel)]="inputValue"
               (ngModelChange)="change($event)"
               (keypress)="onKey($event)"
               (keyup.enter)="sendMessage()"
               [matAutocomplete]="auto"
        />
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)='inputValue= $event.option.value ; sendMessage()'>
          <mat-option *ngFor="let c of questions | appFilter: inputValue" [value]="c">
            {{c}}
          </mat-option>
        </mat-autocomplete>
      </div>
      <label for="fileInput" *ngIf="displayAttachmentIcon">
        <img src="assets/imgs/attach-new.svg" class="attachment-icon" >
      </label>
      <input
          type="file"
          hidden
          id="fileInput"
          accept="image/png, image/jpeg, application/pdf, audio/mpeg, video/mp4"
          (change)="importFile($event.target.files)"
      />
    </div>
  </div>

  <div style="margin-top: 16px; margin-left: 10px;">
    <img src="assets/imgs/send-message-icon.svg" style="cursor: pointer;" (click)="sendMessage()" alt="send">
  </div>
</div>
